<template>
  <div
    class="w-50 text-xs break-words"
    :class="{ 'text-error': showDeclineReason }"
  >
    {{ reason }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { PLACEMENT_STATUS_DECLINED } from "@/helpers/constants";

import type { ILenderPlacement } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ILenderPlacement>,
  },
});

const { getters } = useStore();

const declineReasons = computed<Record<string, string>>(
  () => getters["options/placementAllDeclineReasons"]
);

const declineReason = computed(() => props.model?.decline_reason_id ?? null);
const showDeclineReason = computed(
  () => declineReason.value && props.model?.status === PLACEMENT_STATUS_DECLINED
);
const reason = computed(() =>
  showDeclineReason.value && declineReason.value
    ? declineReasons.value[declineReason.value]
    : "-"
);
</script>
